import { createApp } from 'vue';
import App from './impairment/App.vue';

const app = createApp( App );

app.mount( '#impairment-vue-app' );
